<template>
  <div class="workspace">
    <div class="section-heading">
      <h2>Client Portal</h2>
      <p>Welcome to Authorize Local Client Portal!</p>
      <img src="@/assets/images/how-to-use/how-to-use-header.png" />
    </div>

      <div class="how-to">
        <h1>How to Use Campaign Tools?</h1>
        <div class="doc-box">
          <div class="row pb-8">
            <div class="col-5 mr-12">
              <h3>Complete Your Profile</h3>
              <h4>1. Navigate to Account Settings</h4>
              <p>Open the menu from right top corner of your screeen. From this menu select <strong>Account Settings</strong></p>
              <h4>2. Enter Your Info & Save</h4>
              <p>Simply fill out the form and click <strong>Update Profile</strong> or <strong>Update Settings</strong> button.</p>
            </div>
            <div class="col d-flex justify-content-end">
              <img src="@/assets/images/how-to-use/complete_your_profile.png">
            </div>
          </div>
          <div class="row pb-8">
            <div class="col d-flex justify-content-first">
              <img src="@/assets/images/how-to-use/navigate_connection_page.png">
            </div>
            <div class="col-5 ml-12">
              <h3>Set Your Social Account Links</h3>
              <h4>1. Navigate to Connections Page</h4>
              <p>Click on <strong>Connections</strong> tab from left panel.</p>
              <h4>2. Enter Your Social Links</h4>
              <p>Copy and paste your social account links to each related section. This links will be used to navigate campaign users to your social accounts.</p>
            </div>
          </div>

          <div class="row pb-8">
            <div class="col-5 mr-12">
              <h3>Create Your First Campaign</h3>
              <h4>1. Navigate to Campaigns Page</h4>
              <p>Click on <strong>Campaigns</strong> tab from left panel.</p>
              <h4>2. Click on Create Campaign Button</h4>
              <p>Click on <strong>Create Campaign</strong> tab from top right corner</p>
              <h4>3. Follow the Instructions</h4>
              <p>On this page simply follow the instructions of the form. Each section is marked with colors and numbers.</p>
              <h4>4. Add Multiple Scratch-Off Rewards</h4>
              <p>When you reach the 7th section make sure you are adding more than one rewards for your customers.</p>
              <h4>5. Save & Create</h4>
              <p>When you done with the sections simply click on <strong>Save & Create</strong> button and create your first campaign.</p>
            </div>
            <div class="col d-flex justify-content-end">
              <img src="@/assets/images/how-to-use/create_first_campaign.png">
            </div>
          </div>

          <div class="row pb-8">
            <div class="col d-flex justify-content-first">
              <img src="@/assets/images/how-to-use/test_your_campaign.png">
            </div>
            <div class="col-5 ml-12">
              <h3>Test Your Campaign</h3>
              <h4>1. Navigate to Campaigns Page</h4>
              <p>Click on <strong>Campaigns</strong> tab from left panel.</p>
              <h4>2. Show QR Code</h4>
              <p>Click on <strong>Show QR Code</strong> button under campaign box.</p>
              <h4>3. Click on QR Code</h4>
              <p>After clicking <strong>Show QR Code</strong> a QR Code will showup inside the campaign box.<br>
                This code contains a link to your campaign. You can download and use this code anywhere you like.<br>
                For now, click on it and test your virtual campaign to see if it works properly.</p>
            </div>
          </div>

          <div class="row pb-8">
            <div class="col-5 mr-12">
              <h3>Edit or Delete Your Campaign</h3>
              <h4>1. Navigate to Campaigns Page</h4>
              <p>If you need to change something go back to main <strong>Campaigns</strong> page.</p>
              <h4>2. Edit Your Campaign</h4>
              <p>Click on <strong>Edit</strong> button under campaign box.</p>
              <h4>3. Make Your Changes</h4>
              <p>Make any changes or add more content to your campaign.</p>
              <h4>4. Save Your Changes</h4>
              <p>After you done with the changes click on <strong>Save</strong> button.</p>
              <h4>5. Delete If No Longer Needed</h4>
              <p>Click on <strong>Delete</strong> button under campaign box and delete your campaign.</p>
            </div>
            <div class="col d-flex justify-content-end">
              <img src="@/assets/images/how-to-use/edit_delete_campaign.png">
            </div>
          </div>

          <div class="row pb-8">
            <div class="col d-flex justify-content-first">
              <img src="@/assets/images/how-to-use/share_your_campaign.png">
            </div>
            <div class="col-5 ml-12">
              <h3>Use, Promote or Share Your Campaign</h3>
              <h4>1. Navigate to Campaigns Page</h4>
              <p>Click on <strong>Campaigns</strong> tab from left panel.</p>
              <h4>2. Get Your QR Code</h4>
              <p>Click on <strong>Show QR Code</strong> button under campaign box.</p>
              <h4>3. Download Your QR Code</h4>
              <p>Click on <strong>Download QR Code</strong> button.</p>
              <h4>4. Use Your QR Code Anywhere</h4>
              <p>Now you can use your QR Code wherever you like. Website, brochure, menu, flyer etc.</p>
            </div>

          </div>

          <div class="row pb-8">
            <div class="col-5 mr-12">
              <h3>Managing Rewards</h3>
              <h4>1. Navigate to Reward Manager Page</h4>
              <p>Click on <strong>Reward Manager</strong> tab from left panel.</p>
              <h4>2. Register Customer's Reward Code</h4>
              <p>Enter the code in <strong>Register Code</strong> field. Then click <strong>Register</strong> button.<br>
                This code will be marked as <strong>Used</strong> and it can't be redeemed twice.</p>
              <h4>3. See The Reward Details</h4>
              <p>After you register the code a panel will appear and show you the details such as Customer Name, Reward Item, etc.</p>
              <h4>4. Remind Your Customers Rewards</h4>
              <p>Under <strong>Earned Rewards</strong> tab you can see all your customers rewards.<br>
                Under this tab customers who have not redeemed their rewards are listed.<br>
                You can remind them that they have pending rewards by simply clicking <strong>Send Reminder</strong> button at the end of the list.</p>
            </div>
            <div class="col d-flex justify-content-end">
              <img src="@/assets/images/how-to-use/managing_rewards.png">
            </div>
          </div>

        </div>
      </div>
    </div>
</template>
<script>

export default {
  data () {
    return {
    }
  },
  metaInfo () {
    return {
      title: 'How to use',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'How to use Authorize Local Portal'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  components: {
  },
  mounted () {
  },
  watch: {
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="scss">
.al-dash-module {
  display:none;
  min-width:500px;
  min-height:250px;
  border-radius: 7px;
  box-shadow:0px 0px 10px 1px rgba(0,0,0,.1);
  padding:10px;
}
.mod-head {
  margin-bottom:20px;
}
.task-row{
  &:hover{
    background-color:#f2f2f2;
    transform:translateY(-2px);
    border:1px solid orange;
  }
  &:last-child{
    margin-bottom:0;
  }
  display:flex;
  align-items:center;
  flex-wrap:wrap;
  justify-content: space-between;
  margin-bottom:10px;
  width:100%;
  background-color:#f6f6f6;
  cursor:pointer;
  transition:all .2s ease;
  border:1px solid #fff;
}
.task-col {
  &.task-title {
    width:60%;
    text-align: right;
  }
  &.task-icon{
    width:10%;
  }
  &.task-date{
    width:30%;
    font-size:12px;
    font-weight: 900;
    text-align: left;
  }
  i {
    font-size:20px;
    color:#003451;
  }
  padding:10px;
}
.task-title, .task-date{
  &:hover{
    color:#005488;
  }
}
.section-heading{
  h2 {
    color: var(--Main-Color-Main-80, #006495);
    font-variant-numeric: lining-nums proportional-nums;

    /* Heading Styles/H2 */
    font-family: Poppins;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
  }
  p {
    color: var(--Main-Color-Main-100, #003451);

    /* Paragraph Styles/Paragraph Large */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
  }
  border: none;
  text-align: center;
  justify-content: center;
  display: grid;
}
.workspace {
  padding: 30px 60px;
  background-color: #fff;
  border: none;
}
.how-to {
  padding-top: 40px;
  h1 {
    color: #006495;
    font-variant-numeric: lining-nums proportional-nums;
    font-family: Poppins;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
    text-align: center;
  }
}
.col, .col-5, .col-7 {
  h3 {
    color: var(--Main-Color-Main-60, #0095DF);
    font-variant-numeric: lining-nums proportional-nums;

    /* Heading Styles/H3 */
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; /* 150% */
  }
  h4 {
    color: var(--Main-Color-Main-80, #006495);
    font-variant-numeric: lining-nums proportional-nums;

    /* Heading Styles/H4 */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; /* 140% */
  }
  p {
    color: var(--Main-Color-Main-100, #003451);

    /* Paragraph Styles/Paragraph Large */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    strong {
      color: var(--Primery-Primery-Main-50, #F08028);

      /* Paragraph Styles/Paragraph Large */
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }
  }
}
</style>
